import "./SingleProjectTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ProjectTemplate from "./sections/ProjectTemplate"
import Footer from "@/reusable_sections/Footer"

export default function SingleProjectTemplatePage() {

  return (
    <div>
      <Header />
      <ProjectTemplate />
      <Footer />
    </div>
  )
}
